import styled, { css } from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.color.primaryText};
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: 16px;
  text-align: center;
  min-width: 0;
  width: fit-content;
  margin: 0 auto;
`;

const button = css`
  width: 35px;
  height: 35px;
  color: #fff;
  flex-shrink: 0;
`;

export const MinusButton = styled.button`
  ${button}
  background: ${({ theme }) => theme.buttons.quantityMinus};
`;

export const PlusButton = styled.button`
  ${button}
  background: ${({ theme }) => theme.buttons.quantityPlus};
`;

export const Quantity = styled.div`
  text-align: center;
  flex: 1;
  line-height: 38px;
  font-size: 1.25em;
  min-width: 0;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  max-width: 80px;
`;

export const QuantityInput = styled.input`
  width: auto;
  min-width: 40px;
  text-align: center;
  border: none;
  background: transparent;
  font-size: inherit;
  font-family: inherit;
  outline: none;
  padding: 0;
  margin: 0;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const HiddenQuantityText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
